import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { AuthenticationModule } from 'src/app/authentication/authentication.module';
import { Crew } from 'src/app/generated/services/transportation/crew/crew';
import { SharedModule } from 'src/app/shared/shared.module';
import { CrewChangeServices } from 'src/app/transportation/vessels/crew-change/crew-change.service';

@Component({
  selector: 'app-crew-profile-toolbar',
  templateUrl: './crew-profile-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[SharedModule, AuthenticationModule, MatButtonModule, MatIconModule, MatMenuModule,],
})
export class CrewProfileToolbarComponent {

  crew: Crew = Crew.create();

  constructor(private _router: Router,
    private _crewChangeService: CrewChangeServices) {
  }

  // addAppraisal() {
  //   this._router.navigate(['vessels/crew-change/appraisal', this.crew.id]).then();
  // }

  addCrewChange() {
    this._router.navigate(['vessels/crew-change/crew-change-data-entry/', this.crew.id]).then();
  }

  editCrew() {
    this._router.navigate(['vessels/crew-change/crew/', this.crew.id]).then();
  }

  isCrewAvailable() {
    if (this.crew) {
      return ((this._crewChangeService.getCrewStatus(this.crew) === 'On-board')) ? false :
        (this.crew.remarks && (this._crewChangeService.getLatestStatus(this.crew) === 'blacklisted')) ? false : true;
    }
  }
}
